<div class="empty-content flex flex-col justify-center items-center flex-1-0-100">
  <div class="text-container">
    <img
      src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
      alt="Empty state">
    <h1>Select Countries to Begin</h1>
    <div class="text">
      To continue, please select Country 1 and Country 2 from the filters above. This will allow you to view the CbC automatic exchange status, related agreements, applicable conventions between the selected jurisdictions.
    </div>
  </div>
</div>
